@if (loading()) {
  <div class="global-loading">
    <div class="global-loading__overlay"></div>
    <div class="global-loading__spinner">
      <nz-spin nzSimple nzSize="large" />
    </div>
  </div>
}
